export const engagementInAppMessageCampaignsAndWorkflowsData =
  "/engagement/in_app_message_campaigns_and_workflows_data";
